import React from 'react';
import IconArrow from '../../../_svg/arrow-small.svg';

function PostItem(props) {

    //Fail state for WordPress dashes and hyphens
    function renderText(text) {
        return {__html: text };
    }

    const post = props.data;
    
    const defaultCssClass = `list__item item--${props.postType}`;
    
    let cssClass = props.cssClass ? props.cssClass : defaultCssClass;

    return(
        <li className={cssClass}>
            <a href={post.link}>
                <figure className="item__ico ui-ico ico--arrow">
                    <IconArrow />
                    {/* <img loading="lazy" src={`${wp_core.theme_url}/assets/svg/arrow-small.svg`} /> */}
                </figure>    
                <span className="item__label" dangerouslySetInnerHTML={renderText(post.title.rendered)} />
            </a> 
        </li>         
    )
}

export default PostItem;
